(function () {

    "use strict";

    function basicEntityService($rootScope, $resource, $filter, $mdToast, $mdDialog, $translate, $q) {

        var vm = this;

        vm.instantiate = function (service, labels) {

            service.getItem = function (id) {

                var defered = $q.defer();
                var promise = defered.promise;
                service.entityService.getItem(id).then(function (entity) {
                    defered.resolve(entity);
                }, function () {
                    defered.reject();
                });
                return promise;
            };

            service.getItems = function (filter) {
                var defered = $q.defer();
                var promise = defered.promise;
                service.entityService.getItems(filter).then(function (itmesPaged) {
                    defered.resolve(itmesPaged);
                }, function () {
                    defered.reject();
                });
                return promise;
            };

            service.getMetadatas = function () {

                var defered = $q.defer();
                var promise = defered.promise;
                service.entityService.getMetadatas().then(function (metadatas) {
                    defered.resolve(metadatas);
                }, function () {
                    defered.reject();
                });
                return promise;
            };

            service.save = function (entity) {

                var defered = $q.defer();
                var promise = defered.promise;

                var IsCreate = false;
                var isNotNull = true;
                if (entity.length >= 1) {
                    entity.forEach(function (item) {
                        if (item.id) {
                            IsCreate = true;
                            return IsCreate;
                        }
                    });
                } else if (entity.length == 0) {
                    defered.resolve();
                    isNotNull = false;
                }
                else {
                    if (entity.id) { IsCreate = true; }
                }
                if (isNotNull) {
                    if (IsCreate) {
                        service.entityService.update(entity).then(function (data) {
                            defered.resolve(data);
                        }, function () {
                            var mensaje = $filter('filter')(labels.updateError, entity[labels.propertyName]);
                            $mdToast.show($mdToast.simple().textContent(mensaje).position('top right').theme('error-toast').hideDelay(3000));
                            defered.reject();
                        });
                    }
                    else {
                        service.entityService.save(entity).then(function (data) {
                            defered.resolve(data);
                        }, function () {
                            var mensaje = $filter('filter')(labels.createError, entity[labels.propertyName]);
                            $mdToast.show($mdToast.simple().textContent(mensaje).position('top right').theme('error-toast').hideDelay(3000));
                            defered.reject();
                        });
                    }
                }

                return promise;
            };

            service.new = function () {

                var defered = $q.defer();
                var promise = defered.promise;

                service.getMetadatas()
                    .then(function (metadatas) {

                        var entity = {};
                        entity.id = 0;
                        var metadatasArray = Object.values(metadatas);
                        metadatasArray.forEach(function (metadata) {
                            entity[metadata.internalName] = null;
                        });

                        defered.resolve(entity);
                    });

                return promise;
            };

            service.delete = function (entity) {

                var defered = $q.defer();
                var promise = defered.promise;
                var confirm = $mdDialog.confirm()
                    .title(labels.confirmDeleteTitle)
                    .textContent(labels.confirmDeleteContent)
                    .ariaLabel(labels.confirmDeleteTitle)
                    .ok(labels.confirmDeleteOK)
                    .cancel(labels.confirmDeleteCancel);

                entity = entity.map(function (item) {
                    item.resolved = false;
                    return item;
                });

                $mdDialog.show(confirm).then(function () {
                    entity.forEach(function (item) {
                        service.entityService.remove(item).then(function () {
                            item.resolved = true;
                            if ($filter('filter')(entity, { resolved: false }).length === 0) {
                                defered.resolve(true);
                            }
                        }, function () {
                            item.resolved = true;
                            if ($filter('filter')(entity, { resolved: false }).length === 0) {
                                defered.resolve(true);
                            }
                        });
                    });
                });

                return promise;
            };
            return service;
        };
    }

    basicEntityService.$inject = ["$rootScope", "$resource", "$filter", "$mdToast", "$mdDialog", "$translate", "$q"];

    angular.module("sphforms.main").service("sphforms.basicEntityService", basicEntityService);

})();
